"use client";

import { usePaletteEffect } from "@/lib/palette-store";

/** Renders nothing — exists only to mount the palette-effect hook once at the
 * provider root so <html>'s data-palette / data-theme / data-density attrs
 * track the persisted store. See lib/palette-store.ts. */
export function PaletteEffect() {
  usePaletteEffect();
  return null;
}
